import { SalesWorkOrdersOverview } from '../../features/sales-work-orders';

interface SalesWorkOrdersProps {
  sidebarOpen: boolean;
}

const SalesWorkOrders = (props: SalesWorkOrdersProps) => {
  return <SalesWorkOrdersOverview {...props} />;
};

export default SalesWorkOrders; 